/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosports2ColumnImagesData } from './hosports-2-column-images.data';
import { IHosports2ColumnImagesProps } from './hosports-2-column-images.props.autogenerated';

export interface IHosports2ColumnImagesViewProps extends IHosports2ColumnImagesProps<IHosports2ColumnImagesData> {

}

/**
 *
 * Hosports2ColumnImages component
 * @extends {React.PureComponent<IHosports2ColumnImagesProps<IHosports2ColumnImagesData>>}
 */
class Hosports2ColumnImages extends React.PureComponent<IHosports2ColumnImagesProps<IHosports2ColumnImagesData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default Hosports2ColumnImages;
